import { IonCard, IonCardContent, IonCol, IonRow, IonText, useIonToast } from "@ionic/react";
import { alertCircleOutline, alertOutline, documentOutline, leafOutline, peopleOutline, personOutline, phonePortraitOutline } from "ionicons/icons";
import { useEffect, useState } from "react";

import ActionButton from "../../../components/button/ActionButton";
import InputItem from "../../../components/input/InputItem";
import RadioItem from "../../../components/radio/RadioItem";
import SlideContent from "../../../components/slide-content/SlideContent";
import { Empty } from "../../../layouts/errors/Empty";
import { DataProvider } from "../../../library/DataProvider";
import { passToWebView } from "../../../library/Funcs";
import { CampaignDownloadDocumentOldAction, CampaignDeleteTreeDocsAction } from "../../../redux/actions/Campaign";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";

import "./OldDocs.css";
import Templates from "../../../components/templates/Template";

interface Props {
  project_id: any;
  seedlings: any;
  docs: any;
  changeDocs: any;
  templates: [];
}

const OldDocs: React.FC<Props> = (props) => {
  const [toast, dismiss] = useIonToast();
  const dispatch = useAppDispatch();
  const [templateId, setTemplateId] = useState(0);
  const [docs, setDocs] = useState([] as any);
  const [deleteType, setDeleteType] = useState(0);

  const [dlDocForm, setDlDocForm] = useState({
    seedling: { value: "", validation: { required: true }, error: "" },
    doc_id: { value: "", validation: { required: true }, error: "" },
    donator: { value: "", validation: { required: true }, error: "" },
    memorial: { value: "", validation: { max: 110 }, error: "" },
    gift_name: { value: "", validation: {}, error: "" },
    gift_mobile: { value: "", validation: {}, error: "" },
  });

  const [dlDocFormProvider] = useState(() => new DataProvider(dlDocForm, setDlDocForm));
  const { form_loading, resp } = useAppSelector((state) => state.campaignDownloadDocumentOld);
  const { form_loading2, resp2 } = useAppSelector((state) => state.campaignDeleteTreeDocs);

  useEffect(() => {
    if (props.docs != null) dlDocFormProvider.reset();
  }, [props.docs]);

  useEffect(() => {
    const formDone = () => {
      if (resp != null && !form_loading) {
        if (resp.result) {
          dlDocFormProvider.reset();

          toast({ message: 'پیامک جدید ارسال شد.', duration: 2000, color: "primary" });

          setTemplateId(0);

          props.changeDocs(resp.docs, null);

          passToWebView("sendPayment", resp.link);
        }
      }
    };

    formDone();
  }, [form_loading]);

  useEffect(() => {
    const formDone = () => {
      if (resp2 != null && !form_loading2) {
        if (resp2.result) {
          dlDocFormProvider.reset();

          setTemplateId(0);

          props.changeDocs(resp2.docs, resp2.seedlings);
        }
      }
    };

    formDone();
  }, [form_loading2]);

  const downloadDocumentFormSubmitHandler = (e: any) => {
    e.preventDefault();

    let formValidation = dlDocFormProvider.validation(dlDocForm);

    if (formValidation) {
      dispatch(
        CampaignDownloadDocumentOldAction(
          Number(dlDocForm.doc_id.value),
          templateId,
          dlDocForm.donator.value,
          dlDocForm.memorial.value,
          dlDocForm.gift_name.value,
          dlDocForm.gift_mobile.value
        )
      );
    }
  };

  const changeDocHandler = () => {
    const data = { ...dlDocForm };

    for (let i = 0; i < docs?.length; i++) {
      const doc = docs![i];
      if (doc.id == dlDocForm.doc_id.value) {
        data.donator.value = doc.name;
        data.memorial.value = doc.memorial;
        data.gift_name.value = doc.gift_name;
        data.gift_mobile.value = doc.gift_mobile;
        setTemplateId(doc.template_id);
        break;
      }
    }

    setDlDocForm(data);
  };

  const deleteDocHandler = (doc_id: number = 0) => {
    setDeleteType(doc_id == 0 ? 0 : 1);

    dispatch(CampaignDeleteTreeDocsAction(props.project_id, doc_id));
  };

  const changeSeedlingHandler = () => {
    props.docs?.forEach((el: any) => {
      if (dlDocForm.seedling.value == el.id) {
        setDocs(el.docs);
      }
    });
  };

  return (
    <SlideContent class="old-doc" type="segment">
      <IonCard>
        <Empty length={props.docs?.length} icon={alertCircleOutline} text="سندی وجود ندارد!">
          <IonCardContent>
            <form onSubmit={downloadDocumentFormSubmitHandler}>
              <InputItem name="seedling" type="select2" label="نوع نهال" icon={leafOutline} provider={dlDocFormProvider} change={changeSeedlingHandler}>
                {props.docs?.map((item: any) => {
                  return <RadioItem value={item.id} label={item.type} />;
                })}
              </InputItem>

              <div className="doc-selector">
                <InputItem name="doc_id" type="select2" label="تعداد نهال" icon={documentOutline} provider={dlDocFormProvider} change={changeDocHandler}>
                  {docs?.length > 0
                    ? docs!.map((item: any) => {
                        return <RadioItem value={item?.id} label={item?.name + " - " + item?.saplings + " نهال"} />;
                      })
                    : null}
                </InputItem>
                <div className="delete-container">
                  <ActionButton
                    class="delete-button"
                    text="حذف"
                    loading={form_loading2 && deleteType == 1}
                    color={dlDocForm.doc_id.value != "" ? "red" : "gray"}
                    click={() => deleteDocHandler(parseInt(dlDocForm.doc_id.value))}
                    noSubmit
                  ></ActionButton>
                </div>
              </div>

              <InputItem name="donator" type="text" label="نام اهدا کننده / از طرف" maxlength={50} icon={personOutline} provider={dlDocFormProvider} />

              <InputItem
                name="memorial"
                type="text"
                label="متن یادبود (زیر سند درج می شود)"
                maxlength={110}
                icon={peopleOutline}
                provider={dlDocFormProvider}
              />

              <div>
                <p className="note-text">
                  اگر قصد دارید سند درخت را به شخصی هدیه کنید <strong>نام</strong> و <strong>تلفن همراه</strong> هدیه گیرنده را تکمیل کنید. پس از ثبت یک پیامک حاوی لینک
                  سند درخت برایشان ارسال خواهد شد.
                </p>
                <p className="note-text-danger">در قسمت نام هدیه گیرنده فقط نام را نوشته و از درج عبارت "به نیابت از" خودداری کنید.</p>
              </div>
              <InputItem
                name="gift_name"
                type="text"
                label="نام هدیه گیرنده (به نیابت از ...)"
                icon={personOutline}
                maxlength={50}
                provider={dlDocFormProvider}
              />
              <InputItem
                name="gift_mobile"
                type="tel"
                label="تلفن همراه هدیه گیرنده"
                icon={phonePortraitOutline}
                maxlength={11}
                ltr
                provider={dlDocFormProvider}
              />

              {<Templates type={"tree"} templates={props.templates} templateId={templateId} setTemplateId={setTemplateId} donator={dlDocForm.donator.value} giftName={dlDocForm.gift_name.value} memorial={dlDocForm.memorial.value} />}

              <IonRow>
                <IonCol size="6">
                  <ActionButton text="ویرایش و دریافت سند" loading={form_loading}></ActionButton>
                </IonCol>

                <IonCol size="6">
                  <ActionButton
                    text="حذف همه سندها"
                    loading={form_loading2 && deleteType == 0}
                    color="red"
                    click={() => deleteDocHandler(0)}
                    noSubmit
                  ></ActionButton>
                </IonCol>
              </IonRow>
            </form>
          </IonCardContent>
        </Empty>
      </IonCard>
    </SlideContent>
  );
};

export default OldDocs;
